export default __webpack_public_path__ + "static/media/logoHDM_B.4ea0fc36.png";